import { WhatsappLogo } from "@phosphor-icons/react";

const WHATSAPP_NUMBER = "16472418362";
const WHATSAPP_MSG = encodeURIComponent("Hi Milton 401 Truck Parts! I'd like to ask about a part.");

export const FloatingActions = () => {
  return (
    <div className="fixed right-4 bottom-4 md:right-6 md:bottom-6 z-[60] flex flex-col items-end gap-3" data-testid="floating-actions">
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat on WhatsApp"
        className="flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl hover:scale-105 transition-transform"
      >
        <WhatsappLogo size={32} weight="fill" />
      </a>
    </div>
  );
};

export default FloatingActions;
